function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M11.7253 0H4.27556C1.57333 0 0 1.58222 0 4.29333V13.4756C0 16.2311 1.57333 17.7778 4.27556 17.7778H11.7253C14.4711 17.7778 16 16.2311 16 13.4756V4.29333C16 1.58222 14.4711 0 11.7253 0Z",
  fill: "#C4C4C4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.51551 4.13281V4.1417C4.1324 4.1417 3.82217 4.45281 3.82217 4.83503C3.82217 5.21726 4.1324 5.52837 4.51551 5.52837H7.1724C7.55551 5.52837 7.86662 5.21726 7.86662 4.82526C7.86662 4.44392 7.55551 4.13281 7.1724 4.13281H4.51551ZM11.4844 9.54771H4.51551C4.1324 9.54771 3.82217 9.2366 3.82217 8.85438C3.82217 8.47216 4.1324 8.16016 4.51551 8.16016H11.4844C11.8666 8.16016 12.1777 8.47216 12.1777 8.85438C12.1777 9.2366 11.8666 9.54771 11.4844 9.54771ZM11.4844 13.6101H4.51552C4.24885 13.6456 3.99108 13.5123 3.84885 13.2901C3.70663 13.0589 3.70663 12.7656 3.84885 12.5434C3.99108 12.3123 4.24885 12.1878 4.51552 12.2145H11.4844C11.8391 12.2501 12.1066 12.5523 12.1066 12.9167C12.1066 13.2714 11.8391 13.5745 11.4844 13.6101Z",
  fill: "#C4C4C4"
});

function SvgHchart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHchart);
export default __webpack_public_path__ + "static/media/hchart.041a8973.svg";
export { ForwardRef as ReactComponent };